import { PDFHeader } from "../../../../../global/globalFunctions";
import API from "../../../../../global/api";
import jsPDF from "jspdf";
import _ from "lodash";
import "jspdf-autotable";
import moment from "moment";


export const requestAddInvoice = () => {
    return {
        type: "REQUEST_ADD_INVOICE",
    };
};
export const successAddInvoice = (data) => {
    return {
        type: "SUCCESS_ADD_INVOICE",
        payload: data,
    };
};
export const errorAddInvoice = () => {
    return {
        type: "ERROR_ADD_INVOICE",
    };
};
export const AddInvoiceApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddInvoice());
        API.post(`/invoice/add-invoice`, data).then((res) => {
            dispatch(successAddInvoice(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddInvoice());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetInvoice = () => {
    return {
        type: "REQUEST_GET_INVOICE",
    };
};
export const successGetInvoice = (data) => {
    return {
        type: "SUCCESS_GET_INVOICE",
        payload: data,
    };
};
export const errorGetInvoice = () => {
    return {
        type: "ERROR_GET_INVOICE",
    };
};
export const GetInvoiceApi = () => {
    return (dispatch) => {
        dispatch(requestGetInvoice());
        API.get(`/invoice/get-invoice`).then((res) => {
            let getData = res.data;
            dispatch(successGetInvoice(getData));
        }).catch((error) => {
            dispatch(errorGetInvoice());
        })
    };
};


export const requestDeleteInvoice = () => {
    return {
        type: "REQUEST_DELETE_MACHINE",
    };
};
export const successDeleteInvoice = (user_id) => {
    return {
        type: "SUCCESS_DELETE_MACHINE",
        user_id: user_id,
    };
};
export const errorDeleteInvoice = () => {
    return {
        type: "ERROR_DELETE_MACHINE",
    };
};
export const DeleteInvoiceApi = (id) => {
    return dispatch => {
        dispatch(requestDeleteInvoice());
        API.delete(`/invoice/delete-invoice/${id}`).then(res => {
            dispatch(successDeleteInvoice(id))
        }).catch((error) => {
            dispatch(errorDeleteInvoice())
        });
    }
};


export const PrintInvoicePDF = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Invoice Report");

        const sequenceNumber = "Invoice No: " + data.sequenceNumber;
        const invoiceDate = "Invoice Date: " + moment(data?.invoiceDate).format('DD-MM-YYYY');
        const customer = "Customer: " + data.customerDetails?.customerName;
        const manualInvoiceNo = "Manual Invoice Number: " + data.manualInvoiceNumber;
        const createdBy = "Created By: " + data.userDetails.userName;
        const remarks = "Remarks: " + data.remarks;
        const invoiceTotal = "Invoice Total: " + data.invoiceTotal;

        const headers = [[
            "S.No",
            "Item",
            "Sale Price",
            "Quantity",
            "Total Price",
        ]];
        const prodactData = _.isEmpty(data.data) ? '' : data.data.map((elt, i) => [
            i + 1,
            elt.item,
            elt.salePrice,
            elt.quantity,
            elt.totalPrice,
        ]);
        if (!_.isEmpty(prodactData)) {
            prodactData.push([
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '2').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '3').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
                { content: parseFloat(_.sumBy(prodactData, '4').toFixed()), styles: { halign: "left", fontStyle: "bold" } },
            ])
        }
        let ProductContent = {
            startY: 190,
            startX: 50,
            head: headers,
            styles: { fontSize: 9 },
            body: prodactData,
            theme: "grid",
            headStyles: { fillColor: "#2980ba" },
        };
        doc.autoTable(ProductContent);

        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(sequenceNumber, 50, 130, 0, 20);
        doc.text(invoiceDate, 330, 130, 0, 20);
        doc.text(customer, 50, 145, 0, 20);
        doc.text(manualInvoiceNo, 330, 145, 0, 20);
        doc.text(remarks, 50, 160, 0, 20);
        doc.text(createdBy, 50, 175, 0, 20);
        doc.setFont("Times New Roman", "bold")
        doc.text(invoiceTotal, 400, doc.lastAutoTable.finalY + 20, 0, 20);

        doc.setProperties({ title: `Invoice Report` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};